import { useState } from "react";


export const useUpdateAccountGroupsStates = () => {
  // 口座グループ一覧情報
  const [accountGroupName, setAccountGroupName] = useState("");
  const [isActivateUpdateButton, setIsActivateUpdateButton] = useState(false);

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    accountGroupName,
    setAccountGroupName,
    isActivateUpdateButton,
    setIsActivateUpdateButton,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
